import { Routes } from '@angular/router';

import { authGuard, guestGuard } from '@/app/core/guards';

export const routes: Routes = [
  {
    path: 'auth',
    canMatch: [guestGuard],
    loadComponent: () => import('../layouts').then((layout) => layout.AuthLayout),
    loadChildren: () => import('./auth-routes').then((routes) => routes.AUTH_ROUTES),
  },
  {
    path: 'parents',
    canMatch: [authGuard],
    loadComponent: () => import('../layouts').then((layout) => layout.DefaultLayout),
    loadChildren: () => import('./parents-routes').then((routes) => routes.PARENT_ROUTES),
  },
  {
    path: 'children',
    canMatch: [authGuard],
    loadComponent: () => import('../layouts').then((layout) => layout.DefaultLayout),
    loadChildren: () => import('./children-routes').then((routes) => routes.CHILDREN_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'parents',
  },
];
